'use strict';

module.exports = /* @ngInject */ function () {
    return {
        scope: {
            callBack: '&iframeOnload'
        },
        link: function (scope, element) {
            element.on('load', function () {
                return scope.callBack();
            })
        }
    }
}
